import { GetAllConsultant } from '~/domain/usecases/consultant/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';

import {
  InvalidCredentialsError,
  NotFound,
  BadRequestError,
  UnexpectedError,
} from '~/domain/errors';

export class RemoteGetAllConsultant implements GetAllConsultant {
  private readonly url: string;

  private readonly httpCLient: HttpClient<GetAllConsultant.Model>;

  constructor(url: string, httpClient: HttpClient<GetAllConsultant.Model>) {
    this.url = url;
    this.httpCLient = httpClient;
  }

  getAll = async (
    params: GetAllConsultant.Params,
  ): Promise<GetAllConsultant.Model> => {
    const httpResponse = await this.httpCLient.request({
      url: `${this.url}`,
      method: 'post',
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
